import apiClient, { buildQueryParams } from '../utils/apiClient';
import { handleError } from '../utils/errorHandler';
import { API_ENDPOINTS } from '../constants/apiEndpoints.constants';

/**
 * Service pour les données de référence des véhicules
 * Accessible aux vendors et admins pour remplir les formulaires
 * Utilise les endpoints publics /api/vehicle-reference
 */
const vehicleReferenceService = {
  /**
   * Get all vehicle makes (marques)
   */
  getAllMakes: async (params = {}) => {
    try {
      const {
        page = 1,
        limit = 100,
        search = '',
        status = 'active',
        type = '',
        sortBy = 'createdAt',
        sortOrder = 'desc',
      } = params;

      const queryParams = buildQueryParams({
        page,
        limit,
        search,
        status,
        type,
        sortBy,
        sortOrder,
      });

      return await apiClient.get(`${API_ENDPOINTS.VEHICLE_REFERENCE.MAKES}?${queryParams}`);
    } catch (error) {
      throw new Error(handleError(error, 'vehicleReferenceService.getAllMakes'));
    }
  },

  /**
   * Get all vehicle models (modèles)
   */
  getAllModels: async (params = {}) => {
    try {
      const {
        page = 1,
        limit = 100,
        search = '',
        status = 'active',
        make = '',
        sortBy = 'createdAt',
        sortOrder = 'desc',
      } = params;

      const queryParams = buildQueryParams({
        page,
        limit,
        search,
        status,
        make,
        sortBy,
        sortOrder,
      });

      return await apiClient.get(`${API_ENDPOINTS.VEHICLE_REFERENCE.MODELS}?${queryParams}`);
    } catch (error) {
      throw new Error(handleError(error, 'vehicleReferenceService.getAllModels'));
    }
  },

  /**
   * Get all vehicle fuel types
   */
  getAllFuelTypes: async (params = {}) => {
    try {
      const {
        page = 1,
        limit = 100,
        search = '',
        status = 'active',
        sortBy = 'createdAt',
        sortOrder = 'desc',
      } = params;

      const queryParams = buildQueryParams({
        page,
        limit,
        search,
        status,
        sortBy,
        sortOrder,
      });

      return await apiClient.get(`${API_ENDPOINTS.VEHICLE_REFERENCE.FUEL_TYPES}?${queryParams}`);
    } catch (error) {
      throw new Error(handleError(error, 'vehicleReferenceService.getAllFuelTypes'));
    }
  },

  /**
   * Get all vehicle odometers
   */
  getAllOdometers: async (params = {}) => {
    try {
      const {
        page = 1,
        limit = 100,
        search = '',
        status = 'active',
        sortBy = 'createdAt',
        sortOrder = 'desc',
      } = params;

      const queryParams = buildQueryParams({
        page,
        limit,
        search,
        status,
        sortBy,
        sortOrder,
      });

      return await apiClient.get(`${API_ENDPOINTS.VEHICLE_REFERENCE.ODOMETERS}?${queryParams}`);
    } catch (error) {
      throw new Error(handleError(error, 'vehicleReferenceService.getAllOdometers'));
    }
  },

  /**
   * Get all vehicle features
   */
  getAllFeatures: async (params = {}) => {
    try {
      const {
        page = 1,
        limit = 100,
        search = '',
        status = 'active',
        sortBy = 'createdAt',
        sortOrder = 'desc',
      } = params;

      const queryParams = buildQueryParams({
        page,
        limit,
        search,
        status,
        sortBy,
        sortOrder,
      });

      return await apiClient.get(`${API_ENDPOINTS.VEHICLE_REFERENCE.FEATURES}?${queryParams}`);
    } catch (error) {
      throw new Error(handleError(error, 'vehicleReferenceService.getAllFeatures'));
    }
  },

  /**
   * Get all vehicle locations
   */
  getAllLocations: async (params = {}) => {
    try {
      const {
        page = 1,
        limit = 100,
        search = '',
        status = 'active',
        sortBy = 'createdAt',
        sortOrder = 'desc',
      } = params;

      const queryParams = buildQueryParams({
        page,
        limit,
        search,
        status,
        sortBy,
        sortOrder,
      });

      return await apiClient.get(`${API_ENDPOINTS.VEHICLE_REFERENCE.LOCATIONS}?${queryParams}`);
    } catch (error) {
      throw new Error(handleError(error, 'vehicleReferenceService.getAllLocations'));
    }
  },

  /**
   * Get all vehicle rules
   */
  getAllRules: async (params = {}) => {
    try {
      const {
        page = 1,
        limit = 100,
        search = '',
        status = 'active',
        sortBy = 'createdAt',
        sortOrder = 'desc',
      } = params;

      const queryParams = buildQueryParams({
        page,
        limit,
        search,
        status,
        sortBy,
        sortOrder,
      });

      return await apiClient.get(`${API_ENDPOINTS.VEHICLE_REFERENCE.RULES}?${queryParams}`);
    } catch (error) {
      throw new Error(handleError(error, 'vehicleReferenceService.getAllRules'));
    }
  },

  /**
   * Get all vehicle cancellation policies
   */
  getAllCancellationPolicies: async (params = {}) => {
    try {
      const {
        page = 1,
        limit = 100,
        search = '',
        status = 'active',
        type = '',
        sortBy = 'createdAt',
        sortOrder = 'desc',
      } = params;

      const queryParams = buildQueryParams({
        page,
        limit,
        search,
        status,
        type,
        sortBy,
        sortOrder,
      });

      return await apiClient.get(`${API_ENDPOINTS.VEHICLE_REFERENCE.CANCELLATION_POLICIES}?${queryParams}`);
    } catch (error) {
      throw new Error(handleError(error, 'vehicleReferenceService.getAllCancellationPolicies'));
    }
  },
};

export default vehicleReferenceService;

